import classNames from 'classnames';

type SpinnerColor = 'black' | 'white' | 'danger' | 'blue' | 'brand';

type LoadingSpinnerProps = {
  color?: SpinnerColor;
  className?: string;
};

const COLOR_CONFIG: Record<
  SpinnerColor,
  {
    base: string;
    gradient: string;
  }
> = {
  black: {
    base: 'black',
    gradient: 'black',
  },
  white: {
    base: 'white',
    gradient: 'white',
  },
  danger: {
    base: '#E11900',
    gradient: '#E11900',
  },
  blue: {
    base: '#276EF1',
    gradient: '#276EF1',
  },
  brand: {
    base: '#FF7140',
    gradient: '#FF7140',
  },
};

const LoadingSpinner = ({
  color = 'black',
  className,
}: LoadingSpinnerProps) => {
  const { base, gradient } = COLOR_CONFIG[color];
  const gradientId = `spinner-gradient-${color}`;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames('animate-spin', className)}
    >
      <path
        opacity="0.12"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill={base}
      />

      <path
        d="M12 5C15.866 5 19 8.13401 19 12C19 13.3943 18.5924 14.6933 17.8898 15.7845C17.4413 16.481 17.4246 17.4246 18.0104 18.0104C18.5962 18.5962 19.5567 18.6017 20.0489 17.9354C21.2751 16.2753 22 14.2223 22 12C22 6.47715 17.5228 2 12 2V5Z"
        fill={`url(#${gradientId})`}
      />

      <defs>
        <radialGradient
          id={gradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 11.9892) rotate(-89.888) scale(9.98922 10)"
        >
          <stop stopColor={gradient} stopOpacity="0" />
          <stop offset="0.37" stopColor={gradient} />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default LoadingSpinner;
